import '@descope-ui/descope-list';
import '@descope-ui/descope-list-item';
import '@descope-ui/descope-text';
import '@descope-ui/descope-link';
import '@descope-ui/descope-badge';
import '@descope-ui/descope-icon';

import { componentName, TrustedDevicesClass } from './TrustedDevicesClass';

customElements.define(componentName, TrustedDevicesClass);

export { TrustedDevicesClass, componentName };
